/**
 * @file
 * Global accessibility fixes for contributed modules.
 *
 * Fixes accessibility issues in third-party modules that cannot be
 * patched directly, ensuring WCAG 2.0 A compliance.
 */

(function (Drupal) {
  'use strict';

  /**
   * Fix a single SHS select element.
   *
   * @param {HTMLSelectElement} select - The SHS select element to fix.
   */
  function fixShsSelect(select) {
    // Skip if already fixed
    if (select.hasAttribute('data-a11y-fixed')) {
      return;
    }

    const labelledBy = select.getAttribute('aria-labelledby');
    if (!labelledBy) {
      return;
    }

    const label = document.getElementById(labelledBy);
    if (!label || label.textContent.trim() !== '') {
      return;
    }

    // Determine appropriate label text
    let labelText = '';

    // 1. Check form item for visible label
    const formItem = select.closest('.form-item, .js-form-item');
    if (formItem) {
      const visibleLabel = formItem.querySelector('label:not(.visually-hidden)');
      if (visibleLabel && visibleLabel.textContent.trim()) {
        labelText = visibleLabel.textContent.trim();
      }
    }

    // 2. Check original hidden select for aria-label
    if (!labelText && formItem) {
      const originalSelect = formItem.querySelector('select.shs-enabled.hidden, select.shs-processed.hidden');
      if (originalSelect) {
        const ariaLabel = originalSelect.getAttribute('aria-label');
        if (ariaLabel && ariaLabel !== '- Any -') {
          labelText = ariaLabel;
        }
      }
    }

    // 3. Derive from select ID
    if (!labelText) {
      const selectId = (select.id || '').toLowerCase();
      if (selectId.includes('term') || selectId.includes('tid') || selectId.includes('category') || selectId.includes('topic')) {
        labelText = 'Filter by topic';
      } else if (selectId.includes('year') || selectId.includes('date')) {
        labelText = 'Filter by date';
      } else if (selectId.includes('type')) {
        labelText = 'Filter by type';
      } else {
        labelText = 'Select an option';
      }
    }

    // Apply the fix
    label.textContent = labelText;
    select.setAttribute('data-a11y-fixed', 'true');
  }

  /**
   * Fix SHS (Simple Hierarchical Select) empty labels.
   *
   * Uses MutationObserver to handle dynamically created SHS selects,
   * since the SHS module creates elements after initial page load.
   */
  Drupal.behaviors.shsAccessibilityFix = {
    attach: function (context) {
      // Fix existing SHS selects
      const existingSelects = (context || document).querySelectorAll('.shs-select');
      existingSelects.forEach(fixShsSelect);

      // Watch for new SHS selects being added
      if (context === document || !context) {
        const observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            mutation.addedNodes.forEach(function (node) {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.classList && node.classList.contains('shs-select')) {
                  fixShsSelect(node);
                }
                // Check children
                const childSelects = node.querySelectorAll ? node.querySelectorAll('.shs-select') : [];
                childSelects.forEach(fixShsSelect);
              }
            });
          });
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    }
  };

})(Drupal);
